<template>
  <div class="default-section-container" :class="{ 'dark-mode': darkMode }">
    <h1 v-if="!!title">
      {{ title }}
    </h1>

    <slot name="content" />
  </div>
</template>

<script>
export default {
  name: 'DefaultSection',

  props: {
    title: {
      type: String,
    },

    darkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-section-container {
  width: 100%;
  border-radius: 0;
  transition: all 0.3s ease;
  padding: 0;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;

  h1 {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    transition: color 0.3s ease;
    margin: 1rem 0;
    padding: 1rem 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
  }

  &.dark-mode {
    background: transparent;
    border-bottom-color: #3a4856;

    h1 {
      color: #f0f0f0;
    }
  }
}

@media (max-width: 420px) {
  .default-section-container {
    padding: 0;
    margin-bottom: 0.75rem;

    h1 {
      font-size: 12px;
      margin: 0.75rem 0;
      padding: 0.75rem 0;
    }
  }
}
</style>
